import { useState } from "react";

function ArtInvestingModule() {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (index) => {
    setActiveSection(activeSection === index ? null : index);
  };

  const sections = [
    {
      title: "1. Introduction to Art Investing in Mutual Funds",
      content: [
        "What is Art Investing? Art investing involves purchasing valuable artwork or art-related assets to generate financial returns. Investing in art mutual funds allows investors to pool their money into art-based assets rather than purchasing individual artworks.",
        "Why Invest in Art Mutual Funds? Art mutual funds provide an opportunity to diversify investments into an alternative asset class, offer expert management, and expose investors to the growing art market without needing to buy physical art pieces.",
      ],
    },
    {
      title: "2. Types of Art Investment Funds",
      content: [
        "Direct Art Investment Funds: These funds invest directly in art pieces such as paintings, sculptures, and other high-value artworks. The aim is for long-term appreciation in value.",
        "Art Industry Funds: Invest in companies within the art market, including auction houses, galleries, art marketplaces, and art technology platforms. These funds focus on the commercial side of art.",
        "Art-Backed Securities Funds: These funds invest in companies with large art holdings, allowing indirect exposure to the art market and its potential growth.",
      ],
    },
    {
      title: "3. Why Art Mutual Funds?",
      content: [
        "Diversification: Investing in art provides exposure to a non-correlated asset class, reducing risk by spreading investments across various sectors.",
        "Liquidity: Art mutual funds offer more liquidity than owning physical artwork since shares in the fund can be bought and sold more easily.",
        "Expert Management: Professional fund managers with expertise in art curation and market trends oversee investments, increasing the likelihood of making profitable choices.",
        "Potential High Returns: High-quality art has shown the potential for significant appreciation over time, leading to substantial returns for investors.",
      ],
    },
    {
      title: "4. Risks in Art Investing",
      content: [
        "Valuation Challenges: Art valuation can be subjective and influenced by market trends, which can make it difficult to assess the true value of an artwork.",
        "Market Volatility: Art markets can be volatile, especially during economic downturns or periods of low demand, impacting the fund’s performance.",
        "No Regular Income: Unlike stocks or bonds, art doesn’t generate dividends or interest. The returns come from the potential appreciation of the artwork over time.",
        "High Fees: Art mutual funds tend to have higher management fees compared to traditional equity or bond funds, which can affect overall returns.",
      ],
    },
    {
      title: "5. How to Select an Art Mutual Fund",
      content: [
        "Fund Manager’s Expertise: Look for funds managed by professionals with a solid track record and in-depth knowledge of the art market.",
        "Investment Strategy: Evaluate whether the fund’s investment approach aligns with your goals, such as focusing on contemporary art, classic masterpieces, or art-related companies.",
        "Fee Structure: Understand the fees charged by the fund, including management fees, transaction fees, and performance-based fees.",
        "Past Performance: Research the fund’s historical performance and returns to gauge how well it has performed in different market conditions.",
      ],
    },
    {
      title: "6. Examples of Art Mutual Funds",
      content: [
        "Masterworks Fund: Focuses on high-value, blue-chip artworks by well-known artists like Picasso, Warhol, and Basquiat.",
        "Art Investment Fund I: A fund that invests in both contemporary and classic art, with a diversified portfolio of high-quality pieces.",
        "Art & Culture Fund: Invests in companies involved in the art market, including auction houses and art-related tech firms, for indirect exposure.",
      ],
    },
    {
      title: "7. Taxation and Legal Considerations",
      content: [
        "Tax on Art Investments: Understand the tax implications of art investments, which can vary by country and include capital gains taxes on profits from art sales.",
        "Legal Framework: Familiarize yourself with the regulations surrounding art investment, including ownership rights, provenance, and the legalities of art transactions.",
      ],
    },
    {
      title: "8. Exit Strategy",
      content: [
        "When to Exit? Determine the optimal time to exit based on market conditions and the appreciation of the art assets. It may involve selling individual pieces or liquidating the fund's assets.",
      ],
    },
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-5">Art Investing in Mutual Funds</h1>
      <div className="accordion">
        {sections.map((section, index) => (
          <div key={index} className="mb-3">
            <div
              className="p-3 bg-light border d-flex justify-content-between align-items-center"
              onClick={() => toggleSection(index)}
              style={{ cursor: "pointer", borderRadius: "5px" }}
            >
              <h5 className="m-0">{section.title}</h5>
              <span
                style={{
                  fontSize: "18px",
                  transform: activeSection === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                ▼
              </span>
            </div>
            {activeSection === index && (
              <div className="p-3 bg-white border" style={{ borderRadius: "5px" }}>
                {section.content.map((item, i) => (
                  <p key={i} style={{ margin: "5px 0", fontSize: "14px" }}>
                    ➤ {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ArtInvestingModule;
